var _g, _g2, _defs, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationHommePatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdi_77:2)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_77:2)",
    style: {}
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_77:2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_77:2",
    x: -4,
    y: -6,
    width: 186,
    height: 188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77:2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.454902 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_77:2",
    result: "effect2_dropShadow_77:2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_77:2",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_77:2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_77:2",
    x: 53,
    y: 37,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.454902 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77:2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77:2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_77:2",
    x: 21.8611,
    y: 106.389,
    width: 136.076,
    height: 73.6111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77:2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77:2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_77:2",
    x: 77.5,
    y: 80.4999,
    width: 24.0001,
    height: 13.0002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.47451 0 0 0 0 0.14902 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77:2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77:2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("path", {
    id: "text-path-0",
    d: "M 40.81647872924805 47.860679626464844 Q 74.34141159057617 36.509254455566406 107.8663444519043 47.860679626464844"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_77:2)",
    transform: "matrix(0.348513, -0.050285, 0.117032, 1.600451, 59.522221, -77.335411)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.941847, 0, 0, 1.855878, 66.127472, 117.625198)",
    style: {}
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.273327, 0, 0, 0.249095, -21.934309, -25.661457)",
    style: {}
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 850.394)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.482256, 0, 0, 0.452801, -0.391372, -50.064598)",
    style: {}
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 1.4,
    y: 0,
    width: 500,
    height: 500
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.2,468.5l53-100.6l22.9,13.7c0,0-33.3,110.2-43.3,114.9C272.8,501.2,239.2,507.3,250.2,468.5z",
    style: {
      clipRule: "evenodd",
      fill: "rgb(245, 148, 147)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M295.2,381l30.5,26.9c0,0-25.4,69.9-45.3,94l-25.7,0.1l-13.8-18.4L295.2,381z",
    style: {
      clipRule: "evenodd",
      fill: "rgb(255, 255, 255)",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M 219.6 489.5 C 219.6 465.1 218.971 408 217.984 395.3 C 215.38 362.2 185.21 348 185.21 348 L 157.824 336.1 C 157.734 335.9 157.645 335.7 157.555 335.5 L 158.453 334.9 L 156.657 333.5 C 153.514 327.1 148.576 322.1 140.495 320.6 L 140.584 320.8 L 135.556 317 C 135.826 319.3 135.736 321.4 135.287 323.2 C 134.568 318.6 134.389 313.5 134.479 308 C 143.099 301.1 151.718 291.9 151.718 277.8 L 151.718 276 C 155.4 276.6 159.351 272.6 161.057 266.1 C 162.942 258.9 161.146 251.5 157.196 249.5 C 155.939 248.9 154.682 248.9 153.335 249.4 C 153.873 242.7 154.143 234.6 152.976 227.6 C 153.873 227.3 154.592 226.5 154.682 225.3 C 155.31 215.2 154.053 182.2 112.39 181.4 C 69.381 180.6 71.536 216.6 72.793 225.6 C 72.972 226.7 73.87 227.5 74.858 227.4 C 73.601 234.7 73.87 243.2 74.499 250 C 72.793 248.8 70.997 248.5 69.291 249.4 C 65.34 251.4 63.544 258.8 65.43 266 C 67.315 273.2 71.985 277.5 76.025 275.5 C 76.115 275.5 76.115 275.4 76.205 275.4 L 76.205 276.1 C 76.205 289.5 83.657 299.1 91.649 306.2 C 91.649 310.9 91.469 315.4 91.02 319.4 C 90.841 318.4 90.751 317.3 90.841 316.2 L 88.057 318.5 C 88.057 318.5 82.31 321.2 80.515 324.8 L 71.536 332.2 L 71.536 332.2 L 69.381 333.9 L 47.562 344.9 C 38.134 348.3 27.179 353.1 20.086 359 L 20.086 491 C 20.086 497.1 24.575 502.1 30.052 502.1 L 207.748 501.9 C 211.249 498.8 214.931 495.1 219.6 489.5 Z",
    style: {
      fill: "rgb(46, 71, 135)",
      opacity: 0.31
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M133.5,356.6h3.8c11.6,0,35.9-9.5,35.9-18.8c-22.4-4.3-17.7-34.6-14.8-65.1c0-9.4-9.5-17.1-21.2-17.1h-3.8 c-11.6,0-25.5,10.9-25.5,20.3c-0.7,28.2,5.3,52.7-15.1,61.8C92.9,347,121.9,356.6,133.5,356.6z",
    style: {
      fill: "rgb(245, 148, 147)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M46.9,501.8c0.6-68.8,4.1-149.9,4.1-149.9L85.6,328L98,341.2l53.4-13.2c0,0,52,10,63.6,17.6 c11.6,7.6,10.8,75.3,10.8,75.3s-14.6,54.2-16.1,81.1L46.9,501.8z",
    style: {
      fill: "rgb(67, 106, 230)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M157.2,293c0,19-42.8,18.9-50.9,29c1.9-8.1,2-19.6,1.7-31.7L157.2,293z",
    style: {
      fill: "rgb(214, 116, 116)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M146,310.3c11.3-7.7,29.1-17.7,29.1-37l0-41.6c0-24.7-18.4-45-41-45h-2.3c-22.5,0-41,20.2-41,45v40.1 c0,19.4,17.5,30.9,28.7,38.4C122.7,312.3,142.8,312.5,146,310.3z",
    style: {
      fill: "rgb(245, 148, 147)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.3,253.9c0,2.4-1.4,4.3-3.1,4.3s-3.1-1.9-3.1-4.3c0-2.4,1.4-4.3,3.1-4.3 C115.9,249.6,117.3,251.6,117.3,253.9z",
    style: {
      fill: "rgb(15, 27, 97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M154.7,253.9c0,2.4-1.4,4.3-3.1,4.3s-3.1-1.9-3.1-4.3c0-2.4,1.4-4.3,3.1-4.3 C153.3,249.6,154.7,251.6,154.7,253.9z",
    style: {
      fill: "rgb(15, 27, 97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M104.9,239.6c3.3-0.6,9.5-0.2,12.8,0c7.4,0.6,6.7-7.2,0.3-7.2c-6.2,0-8.6-0.4-12.9,1.5 C100,236.4,103.6,239.9,104.9,239.6z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M161.8,239.6c-3.3-0.6-9.5-0.2-12.8,0c-7.4,0.6-6.7-7.2-0.3-7.2c6.2,0,8.6-0.4,12.9,1.5 C166.8,236.4,163.1,239.9,161.8,239.6z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M79,261.8c2.1,7.2,7.3,11.5,11.8,9.5c4.4-2,6.4-9.4,4.3-16.6c-2.1-7.2-7.3-11.5-11.8-9.5 C78.9,247.1,76.9,254.5,79,261.8z",
    style: {
      fill: "rgb(245, 148, 147)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.5,257.2c0,0,0.1,0,0.1,0c0.6-0.1,1-0.6,1-1.2c0-0.2-0.4-3.9-3-5.7c-1.4-1-3.1-1.2-5.1-0.7 c-0.6,0.2-0.9,0.7-0.8,1.3c0.2,0.6,0.7,0.9,1.3,0.8c1.4-0.4,2.4-0.2,3.3,0.4c1.8,1.2,2.1,4.1,2.1,4.1 C87.5,256.8,87.9,257.2,88.5,257.2z",
    style: {
      fill: "rgb(214, 116, 116)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M85.6,258.9c-0.1,1.6,0.7,2.9,1.8,3c1.1,0.1,2.1-1.2,2.2-2.8c0.1-1.6-0.7-2.9-1.8-3 C86.6,256,85.7,257.3,85.6,258.9z",
    style: {
      fill: "rgb(214, 116, 116)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1834 -0.983 0.983 0.1834 -108.8762 385.3403)",
    className: "st6",
    cx: 177.5,
    cy: 258.2,
    rx: 13.7,
    ry: 8.6,
    style: {
      fill: "rgb(245, 148, 147)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M176,257.2c0.5,0,1-0.4,1.1-1c0,0,0.3-2.9,2.1-4.2c0.9-0.6,1.9-0.7,3.3-0.4c0.6,0.1,1.2-0.2,1.3-0.8 c0.1-0.6-0.2-1.2-0.8-1.3c-2-0.5-3.7-0.3-5.1,0.7c-2.6,1.8-3,5.6-3,5.7c-0.1,0.6,0.4,1.1,1,1.2C176,257.2,176,257.2,176,257.2z",
    style: {
      fill: "rgb(214, 116, 116)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M179,258.9c0.1,1.6-0.7,2.9-1.8,3c-1.1,0.1-2.1-1.2-2.2-2.8c-0.1-1.6,0.7-2.9,1.8-3 C177.9,256,178.9,257.3,179,258.9z",
    style: {
      fill: "rgb(214, 116, 116)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M133.2,274.5c4.7,0,8.2-3.3,8.3-3.4c0.5-0.5,0.6-1.3,0-1.9c-0.5-0.5-1.3-0.6-1.9-0.1c0,0-3.4,3.1-7.3,2.6 c-4-0.5-5.8-2.4-5.9-2.5c-0.5-0.6-1.3-0.6-1.9-0.2c-0.6,0.5-0.6,1.3-0.2,1.9c0.1,0.1,2.4,2.8,7.6,3.5 C132.4,274.5,132.8,274.5,133.2,274.5z",
    style: {
      fill: "rgb(214, 116, 116)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M95.9,210.4c0,0,6.3,34.1-4.9,47.8C90.9,258.2,83,220.7,95.9,210.4z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M170.1,210.4c0,0-6.3,34.1,4.9,47.8C175.1,258.2,183,220.7,170.1,210.4z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M175.1,223.3c1.6,0.5,3.2-0.6,3.3-2.2c0.7-10.1-0.7-43.1-47.1-43.9c-47.9-0.8-45.5,35.2-44.1,44.2 c0.2,1.2,1.3,2,2.5,1.8c4.5-0.8,14.8-3.8,19.1-15.8c16.9,9.2,34,8.8,51.1-0.9C159.9,206.5,164.6,220,175.1,223.3z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M157.2,312.6l25.4,18l-11.6,7l-14.6,19l-17.8-25.5C138.6,331.1,159.5,328.6,157.2,312.6z",
    style: {
      fill: "rgb(77, 133, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M107.2,311.9l-21.6,16l5.1,9.6l29.6,20.3l18.3-26.7C138.6,331.1,106.3,330,107.2,311.9z",
    style: {
      fill: "rgb(77, 133, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M 24.5 358 C 38.3 343.9 79 335.1 79 335.1 L 80.6 396.7 C 80.6 396.7 50.644 382.51 47.654 474.684 L 3.366 435.811 C 3.366 435.911 10.7 372.2 24.5 358 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M40.1,349.1l51.4-23.2c0,0,19.1,13.6,29.3,56.2c12.5,52.5,15,119.8,12.3,119.8l-92.9,0.1l1.5-81.2L40.1,349.1z ",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M225.9,465.9c-4.3,25.7-7.4,36.1-7.4,36.1l-26.5,0c2-39.8-1.4-99.4-1.4-99.4s-0.8-65.9-11.8-72.1l33.7,13.1 C212.5,343.7,232,429.3,225.9,465.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M249,390.9c1.1,12.6,17,86.7,17,111.1l-47.4,0c-10.8-20.8-6-53.5-6-53.5V343.7 C212.5,343.7,246.1,357.8,249,390.9z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M75.9,469c0,0,0-59.2,0-76",
    style: {
      fill: "none",
      stroke: "rgb(158, 185, 219)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M229.8,471.7c0,0-8.7-69.6-17.4-84.1",
    style: {
      fill: "none",
      stroke: "rgb(158, 185, 219)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M104.5,311.4L104.5,311.4c-6.2,4.5-11.8,10.3-10.9,18.6c0.7,6.4,3.7,12.2,4.1,18.8 c0.7,12.9-3.7,25.3-5.1,37.9",
    style: {
      fill: "none",
      stroke: "rgb(20, 37, 133)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M96.3,341.8c7.7,12.5,21.4,22.5,19.2,38.9",
    style: {
      fill: "none",
      stroke: "rgb(20, 37, 133)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M98,392.8l13,43.2c3.2,9.3,5.7,14.3,17.3,11.1c0.4,1.6,0.7,3.3,1,4.9l-1.8,0.5c-8.5,2.6-17.6-2.2-20.1-10.7 l-15.6-51.8C89.2,381.6,95.4,384.5,98,392.8z",
    style: {
      fill: "rgb(191, 212, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M133.8,445.4l-6.3,1.1c-1.8,0.3-2.9,2-2.6,3.8l0.2,0.9c0.3,1.8,2,2.9,3.8,2.6l6.3-1.1c1.8-0.3,2.9-2,2.6-3.8 l-0.2-0.9C137.3,446.3,135.6,445.1,133.8,445.4z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M112.9,389.2l-6.4,44.7c-1.7,9.6-3.5,15-15.5,13.5c-0.1,1.7-0.2,3.4-0.2,5l1.9,0.3c8.8,1.3,17-4.8,18.3-13.6 l7.7-53.6C119.8,376.8,114.1,380.5,112.9,389.2z",
    style: {
      fill: "rgb(191, 212, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M85.2,446.6l6.4,0.2c1.8,0.1,3.2,1.6,3.2,3.4l0,0.9c-0.1,1.8-1.6,3.2-3.4,3.2L85,454 c-1.8-0.1-3.2-1.6-3.2-3.4l0-0.9C81.9,447.9,83.4,446.5,85.2,446.6z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M94.9,389.6l-3.2,0.4c-1.7,0.2-3.2-0.9-3.5-2.6l-0.2-1.7c-0.2-1.7,0.9-3.2,2.6-3.5l3.2-0.4 c1.7-0.2,3.2,0.9,3.5,2.6l0.2,1.7C97.7,387.8,96.5,389.3,94.9,389.6z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M117.4,386.7l-3.3-0.2c-1.7-0.1-3-1.6-2.9-3.3l0.1-1.7c0.1-1.7,1.6-3,3.3-2.9l3.3,0.2c1.7,0.1,3,1.6,2.9,3.3 l-0.1,1.7C120.6,385.5,119.1,386.8,117.4,386.7z",
    style: {
      fill: "rgb(20, 37, 133)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M196.6,413.6c0.2,3.3-5.5,4.2-5.7,1l0,0c-1.5-21.4-1.2-43.2-4.3-64.5c-2-14-9.8-35-27.7-38.1",
    style: {
      fill: "none",
      stroke: "rgb(20, 37, 133)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 5
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9982 -5.969526e-02 5.969526e-02 0.9982 -24.8718 12.1571)",
    className: "st10",
    cx: 191,
    cy: 422.4,
    rx: 15.4,
    ry: 15.4,
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9951 -9.851386e-02 9.851386e-02 0.9951 -40.364 20.8208)",
    className: "st17",
    cx: 190.7,
    cy: 419.1,
    rx: 11.9,
    ry: 11.9,
    style: {
      fill: "rgb(251, 251, 255)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9978 -6.697492e-02 6.697492e-02 0.9978 -27.3336 13.6485)",
    className: "st10",
    cx: 189.9,
    cy: 414.5,
    rx: 11.9,
    ry: 11.9,
    style: {
      fill: "rgb(20, 37, 133)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M118.5,282.7h29.1c0,0-2.2,12.5-14.2,12.5C121.5,295.2,118.5,282.7,118.5,282.7z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M361.5,349.9L339.7,378c-12,9.8-20.4,19-31.2,10.1c-4.8-4-6.7-11.3-6.4-15.2l0.8-12.2l10.6-33c0,0,5.2,1,4,11.7 c-0.5,4.7-3.4,6.5-2.2,9.6c2.1-0.9,4.2-1.9,6.3-3.3l28.1-31c1.9-2.7,6.5-0.4,4.6,2.3l-15.9,24.1l20.8-25.8c2.2-2.5,8.4-2.4,5.2,4.5 l-6.4,10.9l1.7-1.6c2.3-2.4,5.9,1,3.5,3.4l-12.3,19.4l7.7-7.3C360.9,342.2,365,344.7,361.5,349.9z",
    style: {
      fill: "rgb(245, 148, 147)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "st24",
    style: {
      opacity: 0.18
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M31.4,314.5l-16.6-5.2c-1.1-0.3-1.7-1.5-1.4-2.6l5.2-16.6c0.3-1.1,1.5-1.7,2.6-1.4l16.6,5.2 c1.1,0.3,1.7,1.5,1.4,2.6L34,313.2C33.6,314.2,32.5,314.9,31.4,314.5z M18,306l12.7,4l4-12.7l-12.7-4L18,306z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M82.6,145.3c3.1,0,63.7,0,63.7,0",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.9459px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M272.8,336.5c0,2.2-1.8,4-4,4s-4-1.8-4-4c0-2.2,1.8-4,4-4S272.8,334.3,272.8,336.5z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M24,181.5c0,2.2-1.8,4-4,4s-4-1.8-4-4c0-2.2,1.8-4,4-4S24,179.3,24,181.5z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.28
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHommePatient);
export default __webpack_public_path__ + "static/media/illustration-homme-patient.2b1e5c69.svg";
export { ForwardRef as ReactComponent };